// prevent enter key submits the form
$(function () {
    $(document).on("click", function () {
        $('.pac-item').addClass('hideAddressSugestions');
    })

    $('form').on('keyup keypress', function (e) {
        let keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });


    $("#send-quote-form").validate({
        rules: {
          name: "required",
          email: {
            required: true,
            email: true
          }
        },
        messages: {
          name: "Please enter your firstname",
          email: "Please enter a valid email address"
        },
        submitHandler: function(form) {
          validateGoogleMapAutocomplete(form)
        }
      });
});

function validateGoogleMapAutocomplete(form) {
    if ($("div").hasClass('pac-item') && !$("div").hasClass('hideAddressSugestions')) {
        let firstValue = $(".pac-container .pac-item:first .pac-item-query").text() + ", " + $(".pac-container .pac-item:first span:last").text();
        $('#addressWeDoYourQuote').val(firstValue);
        $('.pac-item').addClass('hideAddressSugestions');

        autocomplete.addListener('place_changed');

        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            'address': firstValue
        }, function (results, status) {

            if (status == google.maps.GeocoderStatus.OK 
                && results[0].geometry.hasOwnProperty('location')) {
                    
                let lat = results[0].geometry.location.lat();
                let lng = results[0].geometry.location.lng();

                fillInAddress(lat, lng);

                submitWeDoYourQuote(form)
            }
        });

    } else if ($("#addressWeDoYourQuote").val().length >= 10 && $("#weDoYourQuoteTerritories").val().length == 0) {
        if (!/^.*\w.*\s.*\w.*$/.test($("#addressWeDoYourQuote").val())) {

            $('#addressWeDoYourQuote').addClass('is-invalid').fadeTo(100, 0.2, function () {
                $(this).fadeTo(200, 1);
            });
            return false;
        }

        let address = !/canada/ig.test($("#addressWeDoYourQuote").val()) ? $("#addressWeDoYourQuote").val() + ' Winnipeg MB Canada' : $("#addressWeDoYourQuote").val();

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            'address': address
        }, function (results, status) {

            if (status == google.maps.GeocoderStatus.OK) {
                let lat = results[0].geometry.location.lat();
                let lng = results[0].geometry.location.lng();

                fillInAddress(lat, lng);

                submitWeDoYourQuote(form)
            }
        });

    } else if ($(".pac-container").prop("style")["display"] == 'none' && $("#addressWeDoYourQuote").val().length <= 10) {
        $('#addressWeDoYourQuote').addClass('is-invalid').fadeTo(100, 0.2, function () {
            $(this).fadeTo(200, 1);
        });
        return false;

    } else {

        submitWeDoYourQuote(form)
    }
};

function submitWeDoYourQuote(form) {
    if ($('#weDoYourQuoteTerritories').val() === "") {
        $(form).attr('action', '/customer-help-wanted');        
    }
    form.submit();
}

function pacSelectFirst() {
    let input = document.getElementById('addressWeDoYourQuote');    

    let _addEventListener;

    // store the original event binding function
    if (input && typeof input === "object") {
        if ( "addEventListener" in input) {
            _addEventListener = input.addEventListener;
        } else if ("attachEvent" in input) {
            _addEventListener = input.attachEvent;
        }
    }

    function addEventListenerWrapper(type, listener) {
        // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
        // and then trigger the original listener.
        if (type == "keydown") {
            let orig_listener = listener;
            listener = function (event) {
                // if ($(".pac-container").prop("style")["display"] == 'none' && $("#addressWeDoYourQuote").val().length > 5) {
                //     $("#addressWeDoYourQuote").val("");
                // }
                $("#addressWeDoYourQuote").removeClass("is-invalid");
                let suggestion_selected = $(".pac-item-selected").length > 0;
                if (event.which == 27) {
                    $('.pac-item').addClass('hideAddressSugestions');
                }

                if (event.which == 13 && !suggestion_selected) {
                    let simulated_downarrow = $.Event("keydown", {
                        keyCode: 40,
                        which: 40
                    });
                    orig_listener.apply(input, [simulated_downarrow]);
                }

                orig_listener.apply(input, [event]);
            };
        }
        _addEventListener.apply(input, [type, listener]);
    }

    input.addEventListener = addEventListenerWrapper;
    input.attachEvent = addEventListenerWrapper;

    if (google && typeof google === "object") {
        autocomplete = new google.maps.places.Autocomplete(input);
        autocomplete.addListener('place_changed', fillInAddress);
    }

}

function initAutocomplete() {
    // Create the autocomplete object, restricting the search to geographical
    // location types.
    autocomplete = new google.maps.places.Autocomplete(
        /** @type {!HTMLInputElement} */
        (document.getElementById('addressWeDoYourQuote')), {
            types: ['geocode']
        });

    // Set initial restrict to the greater list of countries.
    autocomplete.setComponentRestrictions({
        'country': ['ca']
    });
    // When the user selects an address from the dropdown, populate the address
    // fields in the form.
    autocomplete.addListener('place_changed', fillInAddress);
}

function fillInAddress(lat = 0, lng = 0) {
    // Get the place details from the autocomplete object.       
    if (lat == 0 && lng == 0) {

        $("#addressWeDoYourQuote_action").val('yes');
        let place = autocomplete.getPlace();
        lat = place.geometry.location.lat();
        lng = place.geometry.location.lng();
    }
    //detact if a point within a zone
    let currentPosition = new google.maps.LatLng(lat, lng);

    //store all territories that a point in
    let inTerritories = [];
    let allActiveTerritories = JSON.parse($("#coords").val());

    //check if a point in the territories
    $.each(allActiveTerritories, function (key, territorie) {

        if (territorie.coordinates) {

            if (getZoneSlug(JSON.parse(territorie.coordinates), currentPosition)) {
                inTerritories.push(territorie.slug);
            }
        }
    })

    $("#weDoYourQuoteTerritories").val(inTerritories.toString());


    /**
     * find in zone
     */
    let inZones = [];
    const allActiveZones = JSON.parse($('#activeZones').val());
    $.each(allActiveZones, (key, zone) => {
        const zoneCoordinates = JSON.parse(zone.coordinates);
        if (zoneCoordinates.length) {
            $.each( zoneCoordinates, (index, coordinates) => {
                const tmpPath = [];
                $.each( coordinates, (index, coordinate) => {
                    $.each(coordinate, (index, co) => {

                        //create path array for rebuilding a polygon
                        tmpPath.push(new google.maps.LatLng(co[1], co[0]));
                    });
                });
                const tmpPolygon =  new google.maps.Polygon({paths:tmpPath});

                //check if a point within a polygon
                if(google.maps.geometry.poly.containsLocation(currentPosition, tmpPolygon) == true){
                    //if a point within a zone, add zone's slug to inZones array
                    $("#zoneSlug").val(zone.slug);    
                }
            });
        }    
    })
}


function getZoneSlug(coordinateSets, currentPosition) {
    let result = false;
    $.each(coordinateSets, function (index, coordinates) {
        let tmpPath = [];
        $.each(coordinates, function (index, coordinate) {
            $.each(coordinate, function (index, co) {

                //create path array for rebuilding a polygon
                tmpPath.push(new google.maps.LatLng(co[1], co[0]));
            });
        });
        let tmpPolygon = new google.maps.Polygon({
            paths: tmpPath
        });

        //check if a point within a polygon
        if (google.maps.geometry.poly.containsLocation(currentPosition, tmpPolygon) == true) {
            result = true;
        }
    });
    return result;
}

function geolocate() {
    if (navigator.geolocation) {    
        navigator.geolocation.getCurrentPosition(successCallback,
            errorCallback, {
                maximumAge: 600000
            }
        );
    }
}

function successCallback(position) {

    let geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
    };
    let circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy
    });

    autocomplete.setBounds(circle.getBounds());
}

function errorCallback(error) {

    navigator.geolocation.watchPosition(function (position) {
            // use allowed traking position
        },
        function (error) {
            if (error.code == error.PERMISSION_DENIED) {
                // user is not being tracked

                let wpgGeolocation = {
                    lat: 49.8998,
                    lng: -97.1375
                };

                let wpgCircle = new google.maps.Circle({
                    center: wpgGeolocation,
                    radius: 12000
                });
                autocomplete.setBounds(wpgCircle.getBounds());
            }
        });
}


$('#addressWeDoYourQuote').focus(() => {
    geolocate();
    pacSelectFirst()    
});